import axios from "../../privateApi";

export const verifyPayment = () => {
  return axios.post("/payments/verify-payment").then((res) => res.data);
};
